module.exports = __webpack_public_path__ + "img/frs4.3de97bf9.jpg";